module.exports = "<p>\n  navbar works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/layout/navbar/navbar.component.html
// module id = ../../../../../src/app/core/components/layout/navbar/navbar.component.html
// module chunks = main